/**
 * bootMapLobbyLoop — Live map loader + lobby/client/match loop (app.js slim).
 */

import { createMapObjectivesController } from './mapObjectivesController.js';
import { wireLiveMapLoader } from './wireLiveMapLoader.js';
import { bootAfterLobby } from './bootAfterLobby.js';

/**
 * @param {object} deps
 */
export function bootMapLobbyLoop(deps) {
  const {
    scene,
    entityInspect,
    mapObjectivesDeps,
    loadLiveMapDeps,
    afterLobbyDeps
  } = deps;

  const mapObjectives = createMapObjectivesController(
    mapObjectivesDeps || { scene }
  );
  const loadLiveMap = wireLiveMapLoader({
    ...loadLiveMapDeps,
    mapObjectives,
    scene
  });

  bootAfterLobby({
    ...afterLobbyDeps,
    mapObjectives,
    entityInspect,
    loadLiveMap
  });

  return { mapObjectives, entityInspect, loadLiveMap };
}
